module.exports = __webpack_public_path__ + "assets/oracle-weblogic-server.af5d3e3e.svg";